import { Component } from '@theme/component';
class MagenelleComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.busy = false;
    this.initJourney();
    this.initGallerySwipe();
  }
  disconnectedCallback() {
    this.gestureController?.abort();
    this.controller?.abort();
    this.journeyObserver?.disconnect();
    cancelAnimationFrame(this.journeyFrame);
    super.disconnectedCallback();
  }
  initJourney() {
    this.journeyFrame = requestAnimationFrame(() => {
      this.journeyObserver?.disconnect();
      const stages = [...this.querySelectorAll('.mg-journey-stage')];
      if (!stages.length) return;
      this.journeyObserver = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting || entry.boundingClientRect.top < 0) entry.target.classList.add('is-lit');
          else entry.target.classList.remove('is-lit');
        }
      }, { rootMargin: '0px 0px -25% 0px', threshold: 0 });
      stages.forEach(stage => this.journeyObserver.observe(stage));
    });
  }
  initGallerySwipe() {
    this.gestureController?.abort();
    this.gestureController = new AbortController();
    const gallery = this.querySelector('.mg-main');
    if (!gallery) return;
    const options = { passive:true, signal:this.gestureController.signal };
    let start = null;
    gallery.addEventListener('touchstart', event => {
      start = event.touches.length === 1 ? { x:event.touches[0].clientX, y:event.touches[0].clientY } : null;
    }, options);
    gallery.addEventListener('touchend', event => {
      if (!start || !matchMedia('(max-width:749px)').matches) return;
      const touch = event.changedTouches[0];
      const dx = touch.clientX - start.x, dy = touch.clientY - start.y;
      start = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) this.moveImage(dx < 0 ? 1 : -1);
    }, options);
    gallery.addEventListener('touchcancel', () => { start = null; }, options);
  }
  previousVideo(event) { this.moveVideo(event, -1); }
  nextVideo(event) { this.moveVideo(event, 1); }
  moveVideo(event, direction) {
    const track = event.target.closest('.mg-video-controls')?.previousElementSibling;
    if (!track?.firstElementChild) return;
    const step = track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    const last = Math.max(0, track.scrollWidth - track.clientWidth);
    let target = Math.min(last, Math.max(0, track.scrollLeft + direction * step));
    if (direction > 0 && track.scrollLeft >= last - 2) target = 0;
    if (direction < 0 && track.scrollLeft <= 2) target = last;
    track.scrollTo({ left:target, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }
  showImage(event) {
    const button = event.target.closest('button[data-image]');
    const image = this.querySelector('.mg-main-photo');
    if (!button || !image) return;
    image.src = button.dataset.image;
    image.removeAttribute('srcset');
    image.alt = button.dataset.alt;
    for (const item of this.querySelectorAll('.mg-thumbs button')) item.setAttribute('aria-pressed', String(item === button));
  }
  previousImage() { this.moveImage(-1); }
  nextImage() { this.moveImage(1); }
  moveImage(direction) {
    const buttons = [...this.querySelectorAll('.mg-thumbs button')];
    const current = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
    const next = buttons[(current + direction + buttons.length) % buttons.length];
    next?.click();
    // Keep the page in place while changing the main photo.
    if (next) { const track = next.parentElement; track.scrollTo({ left:Math.max(0, next.offsetLeft - track.offsetLeft), behavior:'instant' }); }
  }
  selectOffer(event) {
    const choice = event.target;
    if (!(choice instanceof HTMLInputElement) || !choice.checked) return;
    const form = choice.closest('form');
    form.elements.quantity.value = choice.dataset.quantity;
    form.elements.selling_plan.value = choice.dataset.plan;
    form.elements.selling_plan.disabled = !choice.dataset.plan;
    for (const item of this.querySelectorAll('[data-mg-total]')) item.textContent = choice.dataset.price;
    this.querySelector('[data-mg-compare]').textContent = choice.dataset.compare;
    const saving = this.querySelector('[data-mg-save]');
    saving.textContent = choice.dataset.savings;
    saving.hidden = !choice.dataset.savings;
    this.querySelector('[data-mg-terms]').textContent = choice.dataset.terms;
    this.querySelector('[data-mg-shipping]').textContent = choice.dataset.shipping;
    const count = Number(choice.dataset.quantity);
    this.querySelector('[data-mg-error]').textContent = '';
  }
    async openCartDrawer() {
    const response = await fetch('/?sections=cart-drawer-section', { headers: { Accept: 'application/json' } });
    const sections = await response.json();
    const html = sections['cart-drawer-section'];
    const currentSection = document.querySelector('#shopify-section-cart-drawer-section');
    if (html && currentSection) {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const nextSection = documentFragment.querySelector('#shopify-section-cart-drawer-section');
      if (nextSection) currentSection.replaceWith(nextSection);
    }
    await customElements.whenDefined('theme-drawer');
    document.querySelector('cart-drawer-component')?.closest('theme-drawer')?.open();
  }

async addToCart(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    const button = form?.querySelector('button[name=add]');
    if (!button || button.disabled || this.busy) return;
    const choice = form.querySelector('input[name="magenelle_choice"]:checked');
    if (!choice) return;
    this.busy = true;
    button.disabled = true;
    const label = button.firstElementChild;
    const previousLabel = label.textContent;
    label.textContent = this.dataset.adding;
    const errorBox = this.querySelector('[data-mg-error]');
    errorBox.textContent = '';
    this.controller = new AbortController();
    try {
      const quantity = Number(choice.dataset.quantity);
      const item = { id: Number(form.elements.id.value), quantity };
      if (choice.dataset.plan) item.selling_plan = Number(choice.dataset.plan);
      if (choice.dataset.plan && quantity >= 2) item.properties = { 'Included gift': 'Magenelle digital cookbook' };
      const response = await fetch(this.dataset.add, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] }), signal: this.controller.signal
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || this.dataset.error);
            if (choice.value === '3') {
        await fetch('/discount/MAGENELLE65?redirect=' + encodeURIComponent('/cart.js'));
      }
      await this.openCartDrawer();
    } catch (error) {
      if (error.name !== 'AbortError') errorBox.textContent = error.message || this.dataset.error;
    } finally {
      this.busy = false;
      button.disabled = false;
      label.textContent = previousLabel;
    }
  }
}
if (!customElements.get('magenelle-component')) customElements.define('magenelle-component', MagenelleComponent);

